<template>
  <div class="sel-bank-account">
    <vxe-grid
      highlight-hover-row
      auto-resize
      height="auto"
      :loading="loading"
      :pager-config="bankPages"
      :data="bankData"
      :columns="bankColumn"
      showOverflow="ellipsis"
      @cell-click="bankCellClickEvent"
      @page-change="bankPageChange"
    ></vxe-grid>
  </div>
</template>

<script>
import { apiRequest } from "@/utils/api";

export default {
  props: {
    keyWord: String,
    rowIndex: Number
  },
  data() {
    return {
      bankPages: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      }, // 关联主订单分页
      loading: false,
      bankData: [],
      bankColumn: [
        { width: 120, field: "accountName", title: "户名" },
        { width: 260, field: "openBankName", title: "开户行" },
        { width: 200, field: "accountNum", title: "账户号" },
      ],
    };
  },
  watch: {
    keyWord: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          this.search(val);
        }
      },
    },
  },
  methods: {
    bankCellClickEvent({row}) {
        this.$emit("bankAccount", Object.assign(row, {rowIndex: this.rowIndex}));
    },
    bankPageChange(e) {
      let obj = {
        userType: 0,
        page: e.currentPage,
        rows: e.pageSize,
        accountName: this.keyWord
      };
      this.bankPages.currentPage = e.currentPage;
      this.bankPages.pageSize = e.pageSize;
      this.getBankList(obj);
    },
    search(val) {
      let params = {
        page: this.bankPages.currentPage,
        rows: this.bankPages.pageSize,
        userType: 0,
        accountName: val,
      };
      this.getBankList(params);
    },
    async getBankList(obj) {
      let params = obj;
      let res = await apiRequest(
        "api/auth/",
        "baseUserSign/queryUserBankList",
        params
      );
      this.bankData = res.data.rows;
      this.bankPages.total = res.data.total;
    },
  },
};
</script>

<style>
.sel-bank-account {
  width: 600px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
  position: relative;
}
</style>